import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import MetaTags from 'react-meta-tags';
import Favicon from 'react-favicon';


import { Header, Sidebar, Footer } from '../common';
import { userActions, generalActions } from '../../actions';
import { generalConstants } from '../../constants';

class Pages extends React.Component {
    
    constructor(props) {
        super(props);

        this.setMode = this.setMode.bind(this);

        props.dispatch(generalActions.getSetting());

        this.state = {
          miniMode:false
        }

    }

    setMode(e){
        e.preventDefault();
        this.setState({ miniMode: !this.state.miniMode });
        console.log("minimode", this.state.miniMode);
    }

    render() {
    		const { user, setting } = this.props; 
            const { miniMode } = this.state;
                return (
                    <div>
                    <div className={ ( user ? "wrapper" : "" )}>
                        <MetaTags>
                            <title>Antiadmin{ ( setting.data ? " - "+setting.data.site_name : "") }</title>
                            <Favicon url={ ( setting.data ? generalConstants.BASE_URL+setting.data.site_icon : "") }/>
                            <meta name="description" content="Some description." />
                            <meta property="og:title" content="MyApp" />
                            <meta property="og:image" content={ ( setting.data && setting.data != "" ? generalConstants.BASE_URL+setting.data.rich_link : "") } />
                        </MetaTags>
                        { ( user && <Header miniMode={ miniMode } setMode={ this.setMode } siteName={ setting.data ? setting.data.site_name : 'Anti Admin' } /> ) }
                        { ( user && <Sidebar miniMode={ miniMode }/> ) }
                        { this.props.children } 
                        
                    </div>
                    { ( user && <Footer/> ) }
                    </div>
                );
	   
    }
}

function mapStateToProps(state) {
    const { authentication, general } = state;
    const { user } = authentication;
    const { setting, content } = general;
    return {
        user,
        setting,
        content
    };
}

const connectedPages = connect(mapStateToProps)(Pages);
export { connectedPages as Pages };


// WEBPACK FOOTER //
// ./src/components/common/Pages.jsx